import React, { useState, useEffect, useRef, useMemo } from "react";
import { useParams, useNavigate, useLoaderData, useSearchParams } from "react-router-dom";
import { Container, ListGroup } from "react-bootstrap";
import { paramIds } from "./api/ApiUtil";
import { DatasetImage } from "./api/Application";
import { RiArrowUpDownFill } from "react-icons/ri";
import { useUploadImage } from "./hooks/UseDatasets";
import { FileGroup, UploadModal } from "./DatasetImageListPageUploadModal";
import { DatasetImageItem } from "./DatasetImageListPageDatasetImageItem";
import { Button } from "./components/Button";

export function DatasetImageListPage() {
    const nav                                   = useNavigate();
    const { datasetId }                         = paramIds( useParams() );
    const [searchParams, setSearchParams]       = useSearchParams();
    const [showUploadModal, setShowUploadModal] = useState(false);
    const selectedRef                           = useRef<HTMLDivElement>(null);
    const upload                                = useUploadImage( datasetId );
    const images                                = useLoaderData() as DatasetImage[];

    const id = Number( searchParams.get( "imageId" ) );
    const selectedImage = useMemo( () => {
        return images?.find( img => img.datasetImageId === id ) ?? images?.[0] ?? null;
    },
    [searchParams, images] );

    useEffect( () => {
        selectedRef.current?.scrollIntoView( { block: "center", behavior: "instant" } );
    }, [] );

    const handleUpload = (groups: FileGroup[]) => {
        groups.forEach( g => upload.mutate( g.files ) );
    };

    return (
        <div id="capture-list-page">
            <div id="capture-list" className="y-scroll">
                <div className="bg-body-tertiary d-flex flex-row w-100 justify-content-center align-items-center gap-2 p-2">
                    <div className="flex-grow-1 ps-2 fs-5">
                        Dataset Images
                    </div>
                    <Button
                        size="sm"
                        variant="primary"
                        onClick={() => setShowUploadModal( true )}>
                        Upload Images
                    </Button>
                </div>
                <ListGroup variant="flush" className="y-scroll">
                    {images.map( image => (
                        <DatasetImageItem
                            key={image.datasetImageId}
                            image={image}
                            ref={selectedImage?.datasetImageId === image.datasetImageId ? selectedRef : null}
                            onClick={() => setSearchParams({ imageId: String(image.datasetImageId) })}
                            isSelected={selectedImage?.datasetImageId === image.datasetImageId}
                        />
                    ))}
                </ListGroup>
            </div>
            <div className="image-viewer h-100 overflow-hidden position-relative d-flex align-items-center justify-content-center"
                style={{ backgroundColor: "black" }}>
                {selectedImage ? (
                    <div className="text-white text-center">
                        <h4>{selectedImage.name}</h4>
                        <p className="text-muted">Use <RiArrowUpDownFill /> or j/k to navigate, Enter to annotate</p>
                        <Button
                            onClick={() => nav( `/dataset/${datasetId}/image/${selectedImage.datasetImageId}/annotation` )}
                            variant="primary"
                            className="mt-3">
                            Open Annotation Editor
                        </Button>
                    </div>
                ) : (
                    <div className="text-white text-center">
                        <p className="text-muted">Select an image from the list</p>
                    </div>
                )}
            </div>
            <UploadModal
                show={showUploadModal}
                onHide={() => setShowUploadModal(false)}
                onUpload={handleUpload}
                datasetId={datasetId}
            />
        </div>
    );
}